import {registerCrudStore} from '@/libs/core/crud/register-crud-store';
import {TradeModel} from '@/libs/Api';
import {TradesDataService} from '@/libs/trades/trades-data-service';
import {StoreName} from '@/libs/core/store/store-name';

export const tradesStore = registerCrudStore<TradeModel, TradeModel>(StoreName.Trade, new TradesDataService());